export const secureProtocol = 'https://';
